export default __webpack_public_path__ + "static/media/012-no trucks.bf3b4ed9.png";